import React, { useState } from "react"
import CheckForgotPasswordForm from "./CheckForgotPasswordForm/CheckForgotPasswordForm"
import "./CheckForgotPassword.css"

function CheckForgotPassword({ hideForgotPassword, uuid, orderUuid }) {
  const [success, setSuccess] = useState(false)
  const [email, setEmail] = useState("")
  return (
    <div className="CheckForgotPassword">
      <div className="form-container">
        <div className="CheckForgotPasswordTitle">
          <h2>Forgot your password?</h2>
          {!success && <p>Enter your registered mobile number.</p>}
          <hr />
        </div>
        {success ? (
          <div className="form-success">
            <div>
              Your password reset instructions were sent to your email,{" "}
              <span>{email}.</span>
            </div>
            <button
              className="black"
              type="button"
              onClick={hideForgotPassword}
            >
              Return to Log in
            </button>
          </div>
        ) : (
          <CheckForgotPasswordForm
            hideForgotPassword={hideForgotPassword}
            uuid={uuid}
            orderUuid={orderUuid}
            setEmail={setEmail}
            setSuccess={setSuccess}
          />
        )}
      </div>
    </div>
  )
}

export default CheckForgotPassword
